export interface PasswordLoginFormData {
  email: string;
  password: string;
}

export interface SingleSignOnLoginFormData {
  email: string;
}

export type LoginFormData = PasswordLoginFormData | SingleSignOnLoginFormData;

export const isPasswordLoginFormData = (
  formData: LoginFormData,
): formData is PasswordLoginFormData => {
  const { password } = formData as PasswordLoginFormData;

  return typeof password === 'string' && password.length > 0;
};
